import { render, staticRenderFns } from "./ChatPanel.vue?vue&type=template&id=4e3c692a&scoped=true&"
import script from "./ChatPanel.vue?vue&type=script&lang=ts&"
export * from "./ChatPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ChatPanel.vue?vue&type=style&index=0&id=4e3c692a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c692a",
  null
  
)

export default component.exports